// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../../engine/api/http";
import { notification } from "antd";
import {typeAddress} from "../../Addresses/AddresseItem/AddresseHelpers";

const initialState = {
  responsables: [],
  loading: false,
};

export const getResponsables = createAsyncThunk(
  "responsables/getResponsables",
  async (search, thunkAPI) => {
    const res = await http.get(`/responsables?${search}`);
    return res.data;
  },
);

export const newResponsable = createAsyncThunk(
  "responsables/newResponsable",
  async (payload, thunkAPI) => {
    const res = await http.post("/responsables/new", payload);

    return res.data;
  },
);

export const deleteResponsable = createAsyncThunk(
  "responsables/deleteResponsable",
  async (payload, thunkAPI) => {
    const res = await http.delete(`/responsables/${payload._id}`);
    return res.data;
  },
);

export const updateSaveResponsable = createAsyncThunk(
  "responsables/updateSaveResponsable",
  async (payload, thunkAPI) => {
    const res = await http.patch(`/responsables/${payload._id}`, payload);
    return res.data;
  },
);

const responsablesSlice = createSlice({
  name: "responsables",
  initialState,
  reducers: {
    clearResponsables: () => {
      return initialState;
    },
  },
  extraReducers: {
    [getResponsables.pending]: state => {
      state.loading = true;
    },
    [getResponsables.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.responsables = payload;
    },
    [updateSaveResponsable.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [updateSaveResponsable.fulfilled]: (state, { payload }) => {
      state.loading = false;

      state.responsables = state.responsables.map(e => {
        if (e._id === payload._id) {
          return payload;
        } else {
          return e;
        }
      });
      notification.success({
        message: `Responsable modifié`,
      });
    },
    [deleteResponsable.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [deleteResponsable.fulfilled]: (state, { payload }) => {
      state.loading = false;
      const copy = state.responsables.filter(e => e._id !== payload);
      state.responsables = copy;

      if (payload.type === typeAddress.postal) {
        notification.success({
          message: `Responsable supprimée`,
        });
      }

      if (payload.type === typeAddress.maps) {
        notification.success({
          message: `Responsable supprimé`,
        });
      }
    },
    [newResponsable.pending]: state => {
      state.loading = true;
    },
    [newResponsable.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.responsables.push(payload);

      if (payload.type === typeAddress.postal) {
        notification.success({
          message: `Responsable créée`,
        });
      }

      if (payload.type === typeAddress.maps) {
        notification.success({
          message: `Responsable créé`,
        });
      }
    },
    [getResponsables.rejected]: state => {
      state.loading = false;
    },
  },
});

export const {
  updateUnitOnList,
  clearResponsables,
} = responsablesSlice.actions;

export const responsablessReducer = responsablesSlice.reducer;
